<template>
    <TableLayout :permissions="['business:useraction:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="操作人名称" prop="createName">
                <el-input v-model="searchForm.createName" placeholder="请输入操作人名称" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="操作对象" prop="memberName">
                <el-input v-model="searchForm.memberName" placeholder="请输入操作对象" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="所属公司" prop="companyName">
                <el-input v-model="searchForm.companyName" placeholder="请输入所属公司" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="人员类型" prop="memberType">
                <el-select v-model="searchForm.memberType" placeholder="请选择">
                    <el-option label="劳务访客" :value="0"></el-option>
                    <el-option label="普通访客" :value="1"></el-option>
                    <el-option label="内部人员" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="searchForm.mobile" placeholder="请输入手机号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="历史账号状态" prop="beforeStatus">
                <el-select v-model="searchForm.beforeStatus" placeholder="请选择">
                    <el-option label="解冻" :value="0"></el-option>
                    <el-option label="冻结" :value="1"></el-option>
                    <el-option label="拉黑" :value="2"></el-option>
                    <el-option label="恢复" :value="3"></el-option>
                    <el-option label="设为拜访人" :value="4"></el-option>
                    <el-option label="取消拜访人" :value="5"></el-option>
                    <el-option label="设为高级审批人" :value="6"></el-option>
                    <el-option label="取消高级审批人" :value="7"></el-option>
                    <el-option label="手动离场" :value="8"></el-option>
                    <el-option label="删除" :value="9"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="操作类型" prop="type">
                <el-select v-model="searchForm.type" placeholder="请选择">
                    <el-option label="解冻" :value="0"></el-option>
                    <el-option label="冻结" :value="1"></el-option>
                    <el-option label="拉黑" :value="2"></el-option>
                    <el-option label="恢复" :value="3"></el-option>
                    <el-option label="设为拜访人" :value="4"></el-option>
                    <el-option label="取消拜访人" :value="5"></el-option>
                    <el-option label="设为高级审批人" :value="6"></el-option>
                    <el-option label="取消高级审批人" :value="7"></el-option>
                    <el-option label="手动离场" :value="8"></el-option>
                    <el-option label="删除" :value="9"></el-option>
                </el-select>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
            >
                <el-table-column prop="createName" label="操作人员"></el-table-column>
                <el-table-column prop="memberName" label="操作对象"></el-table-column>
                <el-table-column prop="companyName" label="所属公司">
                    <template slot-scope="{row}">
                        <span v-if="row.memberType === '1'">{{row.visitCompanyName}}</span>
                        <span v-else>{{row.companyName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="人员类型">
                    <template slot-scope="{row}">
                        <span v-if="row.memberType === '0'">劳务访客</span>
                        <span v-if="row.memberType === '1'">普通访客</span>
                        <span v-if="row.memberType === '2'">内部人员</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column label="历史状态">
                    <template slot-scope="{row}">
                        <span v-if="row.beforeStatus === 0">解冻</span>
                        <span v-else-if="row.beforeStatus === 1">冻结</span>
                        <span v-else-if="row.beforeStatus === 2">拉黑</span>
                        <span v-else-if="row.beforeStatus === 3">恢复</span>
                        <span v-else-if="row.beforeStatus === 4">设为拜访人</span>
                        <span v-else-if="row.beforeStatus === 5">取消拜访人</span>
                        <span v-else-if="row.beforeStatus === 6">设为高级审批人</span>
                        <span v-else-if="row.beforeStatus === 7">取消高级审批人</span>
                        <span v-else-if="row.beforeStatus === 8">手动离场</span>
                        <span v-else-if="row.beforeStatus === 9">删除</span>
                        <span v-else>正常</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="{row}">
                        <span v-if="row.type === 0">解冻</span>
                        <span v-if="row.type === 1">冻结</span>
                        <span v-if="row.type === 2">拉黑</span>
                        <span v-if="row.type === 3">恢复</span>
                        <span v-if="row.type === 4">设为拜访人</span>
                        <span v-if="row.type === 5">取消拜访人</span>
                        <span v-if="row.type === 6">设为高级审批人</span>
                        <span v-if="row.type === 7">取消高级审批人</span>
                        <span v-if="row.type === 8">手动离场</span>
                        <span v-if="row.type === 9">删除</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" label="操作时间"></el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
    </TableLayout>
</template>

<script>
  import BaseTable from '@/components/base/BaseTable'
  import TableLayout from '@/layouts/TableLayout'
  import Pagination from '@/components/common/Pagination'
  export default {
    name: 'UserAction',
    extends: BaseTable,
    components: { TableLayout, Pagination },
    data () {
      return {
        // 搜索
        searchForm: {
          createName: '',
          memberName: '',
          companyName: '',
          memberType: '',
          mobile: '',
          beforeStatus: '',
          type: ''
        }
      }
    },
    created () {
      this.config({
        module: '人员操作记录日志',
        api: '/business/userAction',
        'field.id': 'id',
        'field.main': 'id'
      })
      this.search()
    }
  }
</script>
